import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './TopBarContainer.css';
import DeletePage from './../top-bar-buttons/delete-page/deletePage';
import AddNewPage from './../top-bar-buttons/add-new-page/addNewPage';
import AddFlyleaf from './../top-bar-buttons/add-flyleaf/addFlyleaf';
import SaveState from './../top-bar-buttons/save-state/saveState';
import Margin from './../top-bar-buttons/margin/margin';
import Colors from './../top-bar-buttons/colors/Colors';
import InsertText from './../top-bar-buttons/insert-text/insertText';
import Help from './../top-bar-buttons/help/help';
import {
  convertObjectToArray,
  GetActivePage,
  hideComponent,
  configExist,
  showAlertModal,
} from './../../../redux/helpers';
import {
  getBookId,
  getDomain } from './../../../redux/helpers/getParams';

import {
  coverWithTextAndWithoutSpine,
  coversWithText } from './../../../helpers/coverHelper';

class TopBarContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hideComponentInAutofill: false,
      hideTopBar: false,
    };
  }

  componentWillMount() {
    if (hideComponent()) {
      this.setState({
        hideComponentInAutofill: true,
      });
    }
  }

  componentDidMount() {
    const { lang } = this.props;
    const bookId = getBookId() === null ? '00' : getBookId();
    const referer = getDomain();
    const editorJSON = configExist('getStateUrl', referer);

    fetch(`${editorJSON}/${bookId}/editorjson`, {
      credentials: 'include',
      cors: 'no-cors',
    })
      .then(response => response.json())
      .then((data) => {
        if ('error' in data && data.error !== 'Json field is empty') {
          showAlertModal(lang.title_notice, lang.authentication_required);
          this.setState({
            hideTopBar: true,
          });
          return false;
        }
      });
  }

  activePage = () => {
    const { byId } = this.props.pages;
    return Object.values(byId).find(element => element.isActive);
  }

  coverText = () => {
    const { coverType } = this.props;
    const { isCover } = this.activePage();
    const coverText = coverWithTextAndWithoutSpine().concat(coversWithText());
    return coverText.some(element => !isCover || element === coverType);
  }

  isInnerPage = () => {
    const { isCover } = this.activePage();
    return isCover;
  }

  renderDeleteComponent = () => {
    const {
      pages,
      isChange,
      lang,
    } = this.props;

    return (
      <DeletePage
        pages={pages}
        isChange={isChange}
        lang={lang}
      />
    );
  }

  renderComponents = () => {
    const { hideComponentInAutofill, hideTopBar } = this.state;

    const {
      pages,
      isChange,
      pageBackgroundColor,
      lang,
      coverType,
      pageBackgroundImage,
      pageBackgroundImageFull,
      sizes,
      ratio,
      bookId,
    } = this.props;

    if (hideComponentInAutofill || hideTopBar) {
      return false;
    }

    const pagesById = convertObjectToArray(pages.byId);
    const hasFrontFlyLeaf = pagesById.some(element => element.isFrontFlyLeaf);
    const hasBackFlyLeaf = pagesById.some(element => element.isBackFlyLeaf);
    const hasCover = pagesById.find(element => element.isCover);
    const activePage = GetActivePage(pages.byId);
    const isCoverPage = activePage.isCover;
    return (
      <div>
        <AddNewPage
          isChange={isChange}
          pages={pages.allIds}
          pagesById={pages.byId}
          pageBackgroundColor={pageBackgroundColor}
          pageBackgroundImage={pageBackgroundImage}
          pageBackgroundImageFull={pageBackgroundImageFull}
          sizes={sizes}
          lang={lang}
          ratio={ratio}
          bookId={bookId}
        />
        { this.renderDeleteComponent() }
        <AddFlyleaf
          pages={pages.allIds.length}
          pagesById={pages.byId}
          allIds={pages.allIds}
          backFlyLeaf={hasBackFlyLeaf}
          frontFlyLeaf={hasFrontFlyLeaf}
          isCover={hasCover}
          isChange={isChange}
          isCoverPage={isCoverPage}
          pageBackgroundColor={pageBackgroundColor}
          pageBackgroundImage={pageBackgroundImage}
          pageBackgroundImageFull={pageBackgroundImageFull}
          sizes={sizes}
          lang={lang}
        />
        <Margin
          lang={lang}
        />
        <Colors
          isCover={activePage.isCover}
          pageId={activePage.id}
          pageOrder={activePage.order}
          pages={pages.allIds}
          lang={lang}
          coverType={coverType}
        />
        { this.coverText() && <InsertText
          lang={lang}
          pageId={activePage.id}
          isTextLayout={this.isInnerPage()}
          coverType={coverType}
        />
        }
        { <Help lang={lang} /> }
      </div>
    );
  }

  render() {
    const {
      lang,
      bookId,
      isLoadable,
    } = this.props;
    const { hideComponentInAutofill } = this.state;

    if (!isLoadable) {
      return null;
    }

    return (
      <div className="Topbar-wrapper">
        { this.renderComponents() }
        <div className="last-elements">
          <SaveState
            lang={lang}
            hideComponent={hideComponentInAutofill}
            bookId={bookId}
          />
        </div>
      </div>
    );
  }
}

TopBarContainer.defaultProps = {
  pageBackgroundColor: '#fff',
  pageBackgroundImage: '',
  isChange: false,
  pages: {},
  lang: {},
  bookId: 1,
  coverType: 'fotos',
  isLoadable: true,
};

TopBarContainer.propTypes = {
  pageBackgroundColor: PropTypes.string,
  pageBackgroundImage: PropTypes.string,
  isChange: PropTypes.bool,
  pages: PropTypes.object,
  lang: PropTypes.object,
  bookId: PropTypes.number,
  coverType: PropTypes.string,
  isLoadable: PropTypes.bool,
};

export default connect(state => ({
  pages: state.entities.pages,
  isChange: state.editorUI.imageChange.isChange,
  pageBackgroundColor: state.editorUI.bookProperties.backgroundColor,
  pageBackgroundImage: state.editorUI.bookProperties.backgroundImage,
  pageBackgroundImageFull: state.editorUI.bookProperties.backgroundImageFull,
  sizes: state.editorUI.bookProperties.backgroundSize,
  bookId: state.bookProperties.photoBookId,
  coverType: state.bookProperties.cover.type,
  ratio: state.bookProperties.bookSizes.ratio,
  isLoadable: state.bookProperties.isLoadable,
}))(TopBarContainer);



// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-container/TopBarContainer.jsx